import { Routes, Route } from 'react-router-dom';
import LocationNew from '../../../pages/manage_database/LocationNew';
import LocationChoice from '../../../pages/manage_database/LocationChoice';
import LocationDelete from '../../../pages/manage_database/LocationDelete';
import LocationRecord from '../../../pages/manage_database/LocationRecord';


const LocationRoutes = () => {
    return <Routes>
         <Route 
            path='/new'
            element={<LocationNew />}
          />
          <Route 
            path='/choice'
            element={<LocationChoice />}
          />
          <Route 
            path='/delete'
            element={<LocationDelete />}
          />
          <Route 
            path='/record/:location_id'
            element={<LocationRecord />}
          />
    </Routes>
}

export default LocationRoutes;